import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

export const containerStyle = {
    padding: {base: '10px', sm: '10px', md: '0', lg: '0'}
}

export const searchInputStyle = {
    variant: 'filled',
    size: 'sm',
    color: 'white',
    bgColor: 'transparent',
    borderWidth: '1px',
    borderColor: 'white',
    width: {base: '100%', sm: '100%', md: pxToRem(252)},
    height: {base: pxToRem(44), sm: pxToRem(44), md: pxToRem(30)},
    fontSize: {base: pxToRem(18), sm: pxToRem(18), md: pxToRem(14)},
    padding: {base: pxToRem(15), sm: pxToRem(15), md: pxToRem(7)},
    letterSpacing: pxToRem(1),
    fontWeight: '500',
    borderRadius: '0',
    _placeholder: {color: 'inherit'},
    _hover: {backgroundColor: 'transparent', _focus: {backgroundColor: 'transparent'}},
    '::-webkit-search-cancel-button': {WebkitAppearance: 'none'},
    '::-ms-clear': {display: 'none'}
}

export const inputRightElementStyle = {
    pointerEvents: 'none',
    right: pxToRem(-5),
    top: '50%',
    transform: 'translateY(-50%)'
}

export const popoverDesktopContentStyle = {
    borderRadius: '0',
    boxShadow: 'none',
    background: 'white',
    p: 0,
    width: {base: '100%', md: pxToRem(395)},
    maxW: pxToRem(395),
    boxSizing: 'border-box',
    fontFamily: fonts.primary,
    display: {base: 'none', md: 'block'}
}

export const popoverArrowStyle = {
    bg: 'white',
    boxSize: pxToRem(20),
    marginLeft: pxToRem(110)
}

export const wrapperBoxStyle = {
    maxHeight: pxToRem(450),
    overflowY: 'auto',
    overflowX: 'hidden',
    px: pxToRem(15)
}

export const mobileDropdownStaticStyle = {
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 20px)',
    background: 'white',
    zIndex: 99,
    borderRadius: '0',
    overflow: 'visible',
    display: {base: 'block', md: 'none'}
}

export const mobileDropdownArrowStaticStyle = {
    position: 'absolute',
    top: pxToRem(-8),
    left: `calc(100% - ${pxToRem(24)})`,
    width: '0',
    height: '0',
    borderLeft: `${pxToRem(8)} solid transparent`,
    borderRight: `${pxToRem(8)} solid transparent`,
    borderBottom: `${pxToRem(8)} solid white`,
    zIndex: 1
}

export const mobileDropdownBoxStyle = {
    px: pxToRem(15),
    py: pxToRem(12),
    overflowY: 'auto',
    maxH: pxToRem(440)
}

export const suggestionsHeaderStyle = {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: pxToRem(14),
    color: 'black',
    marginTop: pxToRem(24),
    marginBottom: pxToRem(8),
    fontFamily: fonts.primary
}

export const phraseLinkStyle = {
    width: '100%',
    py: pxToRem(8),
    fontSize: pxToRem(13),
    color: 'cav_faq_anchor_red',
    textDecoration: 'none',
    textTransform: 'capitalize',
    cursor: 'pointer',
    fontFamily: fonts.secondary,
    _hover: {textDecoration: 'none'}
}

export const featuredHeaderStyle = {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: pxToRem(12),
    marginTop: pxToRem(18),
    marginBottom: pxToRem(16),
    letterSpacing: pxToRem(3),
    color: 'cav_night_rider',
    fontFamily: fonts.secondary
}

export const productsRowStyle = {
    display: {base: 'flex', md: 'grid'},
    flexDirection: {base: 'column', md: undefined},
    gridTemplateColumns: {md: 'repeat(2, 1fr)'},
    gap: pxToRem(16),
    width: {base: '100%', md: '65%'},
    boxSizing: 'border-box',
    fontFamily: fonts.secondary
}

export const productCardStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    background: 'transparent',
    border: {base: '1px solid #E2E8F0', md: 'none'},
    borderBottom: {base: 'none', md: undefined},
    mb: {base: pxToRem(16), md: 0},
    p: {base: pxToRem(8), md: 0},
    flexDirection: {base: 'row', md: 'column'},
    textAlign: {base: 'left', md: 'center'},
    textDecoration: 'none',
    _hover: {textDecoration: 'none'}
}

export const productImageStyle = {
    flexShrink: 0,
    objectFit: 'cover',
    mr: {base: pxToRem(12), md: 0},
    mb: {base: 0, md: pxToRem(8)},
    fontFamily: fonts.secondary,
    fontSize: pxToRem(15),
    width: pxToRem(111),
    height: pxToRem(180)
}

export const productNameStyle = {
    fontSize: pxToRem(13),
    lineHeight: 1.2,
    mb: {base: pxToRem(4), md: pxToRem(4)},
    color: 'black',
    fontFamily: fonts.secondary,
    _hover: {color: 'red.cvs'}
}

export const productPriceStyle = {
    fontWeight: 'bold',
    fontSize: pxToRem(13),
    color: 'black'
}

export const productCardMobileStyle = {
    display: 'flex',
    width: '100%',
    textDecoration: 'none',
    mb: pxToRem(2),
    _hover: {textDecoration: 'none'}
}

export const productImageMobile = {
    flexShrink: 0,
    objectFit: 'cover',
    fontFamily: fonts.secondary,
    fontSize: pxToRem(15),
    width: pxToRem(111),
    height: pxToRem(180)
}
